 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","default~basic-tables-basic-tables-module~views-admins-admins-module~views-base-base-module~views-cus~88682b7d":"default~basic-tables-basic-tables-module~views-admins-admins-module~views-base-base-module~views-cus~88682b7d","views-base-base-module":"views-base-base-module","default~data-tables-data-tables-module~views-admins-admins-module~views-applications-quoteRequests-m~43dcd591":"default~data-tables-data-tables-module~views-admins-admins-module~views-applications-quoteRequests-m~43dcd591","default~views-admins-admins-module~views-applications-quoteRequests-module~views-creditNotes-creditN~43d9f044":"default~views-admins-admins-module~views-applications-quoteRequests-module~views-creditNotes-creditN~43d9f044","default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~03ff6760":"default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~03ff6760","views-settings-engineered-solutions-engineered-solutions-module":"views-settings-engineered-solutions-engineered-solutions-module","views-settings-attributes-attributes-module":"views-settings-attributes-attributes-module","views-settings-surcharges-surcharges-module":"views-settings-surcharges-surcharges-module","views-settings-taxes-taxes-module":"views-settings-taxes-taxes-module","default~data-tables-data-tables-module~views-applications-quoteRequests-module~views-creditNotes-cre~59b19489":"default~data-tables-data-tables-module~views-applications-quoteRequests-module~views-creditNotes-cre~59b19489","default~views-admins-admins-module~views-applications-quoteRequests-module~views-customers-customers~f806d0d3":"default~views-admins-admins-module~views-applications-quoteRequests-module~views-customers-customers~f806d0d3","views-customers-customers-module":"views-customers-customers-module","default~views-banners-banners-module~views-e-brochures-e-brochures-module~views-featured-categories-~b7cb3114":"default~views-banners-banners-module~views-e-brochures-e-brochures-module~views-featured-categories-~b7cb3114","default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~678ceb52":"default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~678ceb52","default~quill~views-news-articles-news-articles-module~views-products-products-module":"default~quill~views-news-articles-news-articles-module~views-products-products-module","default~views-editors-editors-module~views-news-articles-news-articles-module~views-products-products-module":"default~views-editors-editors-module~views-news-articles-news-articles-module~views-products-products-module","default~views-news-articles-news-articles-module~views-products-products-module":"default~views-news-articles-news-articles-module~views-products-products-module","views-news-articles-news-articles-module":"views-news-articles-news-articles-module","views-products-products-module":"views-products-products-module","views-news-categories-news-categories-module":"views-news-categories-news-categories-module","views-vacancies-vacancies-module":"views-vacancies-vacancies-module","views-applications-quoteRequests-module":"views-applications-quoteRequests-module","views-orders-orders-module":"views-orders-orders-module","views-vouchers-vouchers-module":"views-vouchers-vouchers-module","views-creditNotes-creditNotes-module":"views-creditNotes-creditNotes-module","views-admins-admins-module":"views-admins-admins-module","views-manufacturers-manufacturers-module":"views-manufacturers-manufacturers-module","views-banners-banners-module":"views-banners-banners-module","views-e-brochures-e-brochures-module":"views-e-brochures-e-brochures-module","views-featured-categories-featured-categories-module":"views-featured-categories-featured-categories-module","default~views-dashboard-dashboard-module~views-widgets-widgets-module":"default~views-dashboard-dashboard-module~views-widgets-widgets-module","views-dashboard-dashboard-module":"views-dashboard-dashboard-module","views-editors-editors-module":"views-editors-editors-module","views-apps-apps-module":"views-apps-apps-module","views-apps-email-email-module":"views-apps-email-email-module","views-buttons-buttons-module":"views-buttons-buttons-module","views-chartjs-chartjs-module":"views-chartjs-chartjs-module","views-forms-forms-module":"views-forms-forms-module","views-icons-icons-module":"views-icons-icons-module","views-maps-maps-module":"views-maps-maps-module","views-plugins-plugins-module":"views-plugins-plugins-module","views-settings-rebuild-search-rebuild-search-module":"views-settings-rebuild-search-rebuild-search-module","views-theme-theme-module":"views-theme-theme-module","basic-tables-basic-tables-module":"basic-tables-basic-tables-module","data-tables-data-tables-module":"data-tables-data-tables-module","invoicing-invoice-module":"invoicing-invoice-module","advanced-forms-advanced-forms-module":"advanced-forms-advanced-forms-module","basic-forms-basic-forms-module":"basic-forms-basic-forms-module","validation-forms-validation-forms-module":"validation-forms-validation-forms-module","spinners-spinners-module":"spinners-spinners-module"}[chunkId]||chunkId) + "-es2015." + {"common":"7c6a25e660ac546c8132","default~basic-tables-basic-tables-module~views-admins-admins-module~views-base-base-module~views-cus~88682b7d":"da212fef6fa92d1364fc","views-base-base-module":"6de15b48670570472a22","default~data-tables-data-tables-module~views-admins-admins-module~views-applications-quoteRequests-m~43dcd591":"995284828d1594ba3f3f","default~views-admins-admins-module~views-applications-quoteRequests-module~views-creditNotes-creditN~43d9f044":"c7183e87115f332e80c7","default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~03ff6760":"3a12e24ea0afb29670dc","views-settings-engineered-solutions-engineered-solutions-module":"d2d5dea6bec81e37fe48","views-settings-attributes-attributes-module":"8e5b87f962a14ff23519","views-settings-surcharges-surcharges-module":"21a4da757abf45192c91","views-settings-taxes-taxes-module":"8ba0671c9a7a8d48cf12","default~data-tables-data-tables-module~views-applications-quoteRequests-module~views-creditNotes-cre~59b19489":"63cb3ba1b38641adb7bf","default~views-admins-admins-module~views-applications-quoteRequests-module~views-customers-customers~f806d0d3":"f1d74e6bd061b6fdf040","views-customers-customers-module":"7a26646141d6ae7a1483","default~views-banners-banners-module~views-e-brochures-e-brochures-module~views-featured-categories-~b7cb3114":"ed0d5485bfd6cd7f2da5","default~views-news-articles-news-articles-module~views-news-categories-news-categories-module~views-~678ceb52":"61873fb6ead1e53accef","default~quill~views-news-articles-news-articles-module~views-products-products-module":"2f71c68773cd01ce6a95","default~views-editors-editors-module~views-news-articles-news-articles-module~views-products-products-module":"626fc6965a1a24a9a7df","default~views-news-articles-news-articles-module~views-products-products-module":"7ebe4c809329e5cfd84c","views-news-articles-news-articles-module":"337e1c949ad710b5ce42","views-products-products-module":"d7be85fd982dadb1933b","views-news-categories-news-categories-module":"411fdb397a4a557e9c17","views-vacancies-vacancies-module":"841ff310c16da62d8634","views-applications-quoteRequests-module":"11923a12e91cdbe3979d","views-orders-orders-module":"37d4d4718354204c7835","views-vouchers-vouchers-module":"7fccad12610a1933c8ef","views-creditNotes-creditNotes-module":"a508674dbfd9c5a41428","views-admins-admins-module":"b3c19f3b54840af5778d","views-manufacturers-manufacturers-module":"b8f7ffb0a87b02486785","views-banners-banners-module":"820cd197c34f9115df6f","views-e-brochures-e-brochures-module":"6fa5077c0b1bbc4250bf","views-featured-categories-featured-categories-module":"1b01bda09acfa11b5279","default~views-dashboard-dashboard-module~views-widgets-widgets-module":"1a6ce6742e21848c3085","views-dashboard-dashboard-module":"9ce26e36667db7b7ac35","views-editors-editors-module":"1811db32dc1f3f4c7cb1","views-apps-apps-module":"5f2187884fa80f62dc01","views-apps-email-email-module":"376bb8a6965f02ab1503","views-buttons-buttons-module":"66ec5826439a7dadbb7c","views-chartjs-chartjs-module":"f4bf7f850c04905d8d06","views-forms-forms-module":"6d797721b838d75cb60c","views-icons-icons-module":"979b782149729f4eea7e","views-maps-maps-module":"d426c093032eb035acc4","views-plugins-plugins-module":"fa88f68c02db2b9be96b","views-settings-rebuild-search-rebuild-search-module":"14d5f754e5272125a91f","views-theme-theme-module":"7cc4d9a4bdbae53fc672","basic-tables-basic-tables-module":"2638111ff482ba257961","data-tables-data-tables-module":"91f905840c2e30f9c8b9","invoicing-invoice-module":"083d358de8bb15e819fa","advanced-forms-advanced-forms-module":"ac154bc660b38f6a7bb7","basic-forms-basic-forms-module":"87a39332319423805513","validation-forms-validation-forms-module":"3abc623a93a0f0c6e045","spinners-spinners-module":"65c472056a496f47980a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
